import { GzNavigationButtonWebComponent } from './component/GzNavigationButtonWebComponent';

export { GzNavigationButtonWebComponent };
